import { Reducer } from 'redux';

import { IProceduresEmailsState } from 'types/proceduresEmails.types';
import * as authConstants from 'redux/constants/auth.constants';
import * as constants from 'redux/constants/proceduresEmails.constants';

export const defaultState: IProceduresEmailsState = {
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'createdAt',
    sortType: 'desc',
  },
};

const proceduresReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.PROCEDURES_EMAILS_ON_GET_ALL_REQUESTED:
    case constants.PROCEDURES_EMAILS_ON_RESEND_REQUESTED:
    case constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.PROCEDURES_EMAILS_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.PROCEDURES_EMAILS_ON_RESEND_SUCCEEDED:
    case constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_SUCCEEDED:
    case constants.PROCEDURES_EMAILS_ON_GET_ALL_FAILED:
    case constants.PROCEDURES_EMAILS_ON_RESEND_FAILED:
    case constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default proceduresReducer;
